import React from "react"
import * as S from "./hero.styles"
import ArrowForwardIcon from "@mui/icons-material/ArrowForward"

const Hero = ({ image, text, shadow, haveBanner, button }) => {
  return (
    <>
      <S.Wrapper>
        {image && (
          <S.Hero img={image} shadow={shadow}>
            {text && (
              <S.ContainerWrapper>
                <h1>{text}</h1>
                {button?.title && button?.url && (
                  <S.Button
                    href={button.url}
                    target={button.target}
                    className="red"
                  >
                    <S.ButtonWrapper>
                      <ArrowForwardIcon />
                      {button.title}
                    </S.ButtonWrapper>
                  </S.Button>
                )}
              </S.ContainerWrapper>
            )}
          </S.Hero>
        )}
      </S.Wrapper>
      {haveBanner && (
        <S.Banner>
          <S.Marquee>
            <S.Track>
              <S.Content>
                <S.Separator />
                <S.Title>WE ARE OPEN</S.Title>
                <S.Separator />
                <S.TransparentTitle>
                  WE ARE OPEN
                </S.TransparentTitle>
                <S.Separator />
                <S.Title>WE ARE OPEN</S.Title>
                <S.Separator />
                <S.TransparentTitle>
                  WE ARE OPEN
                </S.TransparentTitle>
                <S.Separator />
                <S.Title>WE ARE OPEN</S.Title>
                <S.Separator />
                <S.TransparentTitle>
                  WE ARE OPEN
                </S.TransparentTitle>
                <S.Separator />
                <S.Title>WE ARE OPEN</S.Title>
                <S.Separator />
                <S.TransparentTitle>
                  WE ARE OPEN
                </S.TransparentTitle>
                <S.Separator />
                <S.Title>WE ARE OPEN</S.Title>
                <S.Separator />
                <S.TransparentTitle>
                  WE ARE OPEN
                </S.TransparentTitle>
                <S.Separator />
                <S.Title>WE ARE OPEN</S.Title>
                <S.Separator />
                <S.TransparentTitle>
                  WE ARE OPEN
                </S.TransparentTitle>
                <S.Separator />
                <S.Title>WE ARE OPEN</S.Title>
                <S.Separator />
                <S.TransparentTitle>
                  WE ARE OPEN
                </S.TransparentTitle>
              </S.Content>
            </S.Track>
          </S.Marquee>
        </S.Banner>
      )}
    </>
  )
}

export default Hero
